const QueryString = require("query-string");
const {AJAX_TIMEOUT, runAjax, hasPermRole} = require("./ElevHelpers");

//
// JS for login / logout computations
//

function runAjaxAuthenticate(cb) {
	return runAjax(
		{
			endpoint: "/api/user/current",
			timeout: AJAX_TIMEOUT,
		},
		cb
	);
}

// Given a loaded user that just logged in, return the URL that they should be
// redirected to.
function getRedirectURLAfterUserSignIn(user, qsString) {
	if (qsString) {
		const qsObject = QueryString.parse(qsString);
		if (
			qsObject &&
			typeof qsObject.url === "string" &&
			qsObject.url !== "null"
		) {
			return qsObject.url;
		}
	}

	// Largely mimics OpsPage.getDefaultRequestedPage
	if (!user) {
		return "/";
	}

	if (
		hasPermRole(user, "student") ||
		hasPermRole(user, "student deactivated")
	) {
		return "/school";
	}

	if (hasPermRole(user, "parent")) {
		return "/parent/students";
	}

	const staffRoles = user.staffRoles || {};
	if (
		user.staffForPurchaseID &&
		staffRoles.active &&
		hasPermRole(user, "teacher")
	) {
		if (staffRoles.adminPurchase) {
			return "/dashboard/accounts/system/schools";
		} else if (
			staffRoles.teachClassIDs.length ||
			staffRoles.adminSchoolIDs.length
		) {
			return "/dashboard/reports/system/schools";
		} else if (staffRoles.teachClassIDs.length === 0) {
			return "/dashboard/reports/system/classes";
		}
	}

	return "/";
}

module.exports = {
	runAjaxAuthenticate,
	getRedirectURLAfterUserSignIn,
};
